var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes, attrs: { role: _vm.role } }, [
    _c("div", { class: _vm.mdsNS("alert__cell-icon") }, [
      _c(
        "svg",
        {
          class: _vm.mdsNS("icon alert__icon"),
          attrs: { "aria-hidden": "true" }
        },
        [_c("use", { attrs: { "xlink:href": _vm.iconId } })]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [_vm.mdsNS("alert__cell-body"), _vm.namespace("__message-info")]
      },
      [
        _c("aside", { class: _vm.mdsNS("alert__content") }, [
          _vm._v(_vm._s(_vm.message))
        ])
      ]
    ),
    _vm._v(" "),
    _vm.dismissible
      ? _c(
          "button",
          {
            class: _vm.mdsNS(
              "button button--small button--icon-only alert__dismiss-button"
            ),
            attrs: { type: "button" },
            on: { click: _vm.close }
          },
          [
            _c(
              "svg",
              {
                class: _vm.mdsNS("icon button__icon button__icon--right"),
                attrs: { "aria-hidden": "true" }
              },
              [
                _c("use", { attrs: { "xlink:href": "#remove--s" } }, [
                  _c("title", [_vm._v("Remove")])
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }